import { FlexRow } from '@/src/components'
import { BaseText } from '@/src/components/BaseText'
import { appColors } from '@/src/theme'
import { Box } from '@chakra-ui/react'
import { Info as InfoIcon } from 'react-feather'

interface SimulationChangeStatusInfoBoxProps {
  text: string
}

export const LoadPlanningMeasureModalInfoBox = ({ text }: SimulationChangeStatusInfoBoxProps) => {
  return (
    <Box bg={appColors.amber['100']} border='1px solid' borderColor={appColors.amber['400']} borderRadius='md' mt={'0px'} p='8px'>
      <FlexRow gap='8px' alignItems='flex-start' color={appColors.amber['800']}>
        <InfoIcon size={16} color={appColors.amber['800']} style={{ minWidth: 16, minHeight: 16, marginTop: 2 }} />
        <BaseText whiteSpace='pre-line'>{text}</BaseText>
      </FlexRow>
    </Box>
  )
}
